<template>
  <div class="vx-row">
    <div v-can="'view-orders-additional-costs-setting'" class="w-full vx-col">
      <vx-card :title="'ORDERS ADDITIONAL COST RULES'" class="">
        <template slot="actions">
          <vs-button @click.stop="onClickAdd" icon-pack="feather" icon="icon-plus" class="mr-4" color="primary"
            type="filled">create</vs-button>
        </template>
        <div id="margin-list-table" class="vx-row">
          <div class="w-full vx-col">

            <vs-table stripe sort class="mt-8" :data="sundry_cost_list">
              <template slot="thead">
                <vs-th width="10%">NAME/DESCRIPTION</vs-th>
                <vs-th>NOMINAL CODE</vs-th>
                <vs-th width="10%">APPLIED PRODUCT TYPES</vs-th>
                <vs-th width="10%">CONSITION</vs-th>
                <vs-th width="10%">CONDITION QUANTITY (KG)</vs-th>
                <vs-th width="10%">AMOUNT(S)</vs-th>
                <vs-th width="20%">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr @click.native="onClickUpdate(data[indextr].id)" class="cursor-pointer" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name }}
                  </vs-td>

                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].sage_nominal_code ? data[indextr].sage_nominal_code.code : 'N/A' }}
                  </vs-td>

                  <vs-td :data="data[indextr].note">
                    {{ data[indextr].product_types.toString() }}
                  </vs-td>

                  <vs-td :data="data[indextr].condition">
                    {{ generateConditionText(data[indextr].condition) }}
                  </vs-td>

                  <vs-td :data="data[indextr].quantity">
                    {{ data[indextr].quantity }}
                  </vs-td>

                  <vs-td :data="data[indextr].currencies">
                    <div v-for="(currency, index) in data[indextr].currencies" :key="index+'currency'">
                      {{ currency.currency }} {{ currency.amount }} <br>
                    </div>
                  </vs-td>

                  <vs-td :data="data[indextr].name">
                    <div class="justify-start vx-row" v-can="'edit-sundry-costs-setting'">
                      <vx-tooltip text="View/Update" position="left">
                        <vs-button @click.stop="onClickUpdate(data[indextr].id)" class="ml-3" size="small"
                          color="warning" type="border" icon-pack="feather" icon="icon-edit-2"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip text="Remove" position="left">
                        <vs-button @click.stop="openConfirm(data[indextr].id)" class="ml-3" size="small" color="danger"
                          type="border" icon-pack="feather" icon="icon-trash-2"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>

                </vs-tr>
              </template>

            </vs-table>
            <vs-pagination v-on:changeMaxItems="changePage" :size-array="meta.total ? meta.total : 20"
              :max-items="perPage" description-body="Rows per page" description-connector="of"
              description-title="Records" description :description-items="descriptionItems"
              :total="(meta.last_page) ? meta.last_page : 0" v-model="page" class="p-5">
            </vs-pagination>


          </div>
        </div>
      </vx-card>
    </div>

    <div v-can="'view-sales-order-changes-reasons-setting'" class="w-full vx-col mt-5" id="sos-change-reasons-page">
    <div class="vx-row">
     <div class="w-full vx-col">
        <vx-card :title="`REASONS FOR SOS REMOVAL/REDUCTION IN SOS`">
          <template slot="actions">
          <vs-button v-can="'edit-sales-order-changes-reasons-setting'" @click="openCreatePopup" icon-pack="feather" icon="icon-plus" class="mr-4" color="primary"
            type="filled">create</vs-button>
          </template>
          <!-- Table -->
          <div id="margin-list-table2" class="vx-row">
          <div class="w-full vx-col">
          <vs-table
            :data="reasons"
          >
            <template slot="thead">
              <vs-th>REASON</vs-th>
              <vs-th>CREATED AT</vs-th>
              <vs-th>UPDATED AT</vs-th>
              <vs-th>ACTION</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :key="index" v-for="(reason, index) in data">
                <vs-td :data="reason.reason">
                  {{ reason.reason }}
                </vs-td>
                <vs-td :data="reason.created_at">
                  {{ formatDate(reason.created_at) }}
                </vs-td>

                <vs-td :data="reason.updated_at">
                  {{ formatDate(reason.updated_at) }}
                </vs-td>
                <vs-td>
                  <div class="flex items-center gap-2">
                    <!-- Edit Button -->
                    <vx-tooltip text="Edit" position="top">
                      <vs-button 
                        v-can="'edit-sales-order-changes-reasons-setting'"
                        @click.prevent="openEditPopup(reason)"
                        size="small" 
                        color="primary" 
                        type="border" 
                        icon-pack="feather" 
                        icon="icon-edit"
                      />
                    </vx-tooltip>

                    <!-- Delete Button -->
                    <vx-tooltip text="Delete" position="top">
                      <vs-button 
                        v-can="'edit-sales-order-changes-reasons-setting'"
                        @click.prevent="confirmDelete(reason.id)"
                        size="small" 
                        color="danger" 
                        type="border" 
                        icon-pack="feather" 
                        icon="icon-trash"
                      />
                    </vx-tooltip>
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          </div>
          </div>
           <vs-pagination 
              v-on:changeMaxItems="changeReasonsPage" 
              :size-array="reasonsMeta.total ? reasonsMeta.total : 20"
              :max-items="reasonsPerPage" 
              description-body="Rows per page" 
              description-connector="of"
              description-title="Records" 
              description 
              :description-items="reasonsDescriptionItems"
              :total="(reasonsMeta.last_page) ? reasonsMeta.last_page : 0" 
              v-model="reasonsPage" 
              class="p-5"
            />
        </vx-card>
      </div>
    </div>

    <!-- Create/Edit Popup -->
    <sos-reason-popup
      ref="sosReasonPopup"
      @saved="fetchReasons"
    />
  </div>
    <add-order-additional-cost-pop-up ref="addOrderAdditionalCostPopUp" />
  </div>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory';
import AddOrderAdditionalCostPopUp from '@/components/popups/settings/orders-additional-cost/AddOrderAdditionalCostPopUp.vue';
import SosReasonPopup from '@/components/popups/settings/orders-additional-cost/SosReasonPopup.vue';
import Filter from '@/mixins/filter';
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

import { defaultPagination, perPageList } from "@/constants/config";
const CustomerRepository = RepositoryFactory.get('customer')
const AdditionalCostRepository = RepositoryFactory.get('additional_cost');

export default {
  name: "OrderAdditionalCostSettings",
  data() {
    return {
      sundry_cost_list: [],
      filters: {},
      page: 1,
      total: 0,
      meta: {},
      sort: '',
      perPage: defaultPagination,
      descriptionItems: perPageList,
      reasons:[],
      reasonsPage: 1,
      reasonsPerPage: 20,
      reasonsMeta: {},
      reasonsDescriptionItems: [20, 50, 100]
    }
  },
  components: {
    AddOrderAdditionalCostPopUp,
    SosReasonPopup
  },
  methods: {
    async refreshData() {
      await this.fetchSundryCostList()
    },
    async fetchReasons() {
        try {
          const response = await CustomerRepository.getSosChangeReasons({
            paginate: this.reasonsPerPage,
            is_paginate: 1,
            page: this.reasonsPage
          })
          this.reasons = response.data.data
          this.reasonsMeta = response.data.meta || response.data
        } catch (error) {
          console.error('Error fetching reasons:', error)
          this.$vs.notify({
            title: 'Error',
            text: 'Failed to load reasons',
            color: 'danger'
          })
        }
      },
    async fetchSundryCostList() {
      await this.$vs.loading({
        container: '#margin-list-table',
        scale: 0.45
      })
      const { data } = await AdditionalCostRepository.getAdditionalCostList(this.page, this.filterQuery, this.perPage, this.sort)
      this.sundry_cost_list = data.data
      this.meta = data.meta
      this.$vs.loading.close('#margin-list-table > .con-vs-loading')
    },
    async onClickAdd() {
      await this.$refs.addOrderAdditionalCostPopUp.openPopup()
    },
    async onClickUpdate(id) {
      await this.$refs.addOrderAdditionalCostPopUp.openPopup(id)
    },
    openConfirm(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Confirm`,
        text: 'Are you sure you want to delete this ?',
        accept: this.onClickDelete,
        parameters: [id]
      })
    },
    async onClickDelete(params) {
      try {
        await AdditionalCostRepository.deleteAdditionalCost(params[0])
        await this.fetchSundryCostList()
        await this.showSuccessMessage('Sundry cost deleted!');
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    filterQueryUpdate() {
      this.fetchSundryCostList()
    },

    handleChangePage(page) {
      this.page = page;
      this.fetchSundryCostList()
    },
    handleSort(key, active) {
      if (key) {
        active = (active === 'desc') ? "-" : '';
        this.sort = active + key;
        this.fetchSundryCostList()
      }
    },
    changePage(index) {
      this.perPage = this.descriptionItems[index]
    },
    changeReasonsPage(val) {  // Renamed from changePage
    this.reasonsPerPage = val
    this.reasonsPage = 1
    this.fetchReasons()
  },
    generateConditionText(condition) {
      if (condition === 'lt') {
        return 'Less than'
      } if (condition === 'lte') {
        return 'Less than or equal'
      } if (condition === 'gt') {
        return 'Greater than'
      } if (condition === 'gte') {
        return 'Greater than or equal'
      } if (condition === 'eq') {
        return 'Equal'
      }
    },
    openCreatePopup() {
      this.$refs.sosReasonPopup.openPopup()
    },

    openEditPopup(reason) {
      this.$refs.sosReasonPopup.openPopup(reason)
    },

    confirmDelete(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: 'Are you sure you want to delete this reason?',
        accept: () => this.deleteReason(id)
      })
    },

    async deleteReason(id) {
      try {
        await CustomerRepository.deleteSosChangeReason(id)
        this.$vs.notify({
          title: 'Success',
          text: 'Reason deleted successfully',
          color: 'success'
        })
        this.fetchReasons()
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: (error.response && error.response.data && error.response.data.message) || 'Failed to delete reason',
          color: 'danger'
        })
      }
    },
      formatDate(dateString) {
      if (!dateString) return 'N/A'
      
      const date = new Date(dateString)
      const day = String(date.getDate()).padStart(2, '0')
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const year = date.getFullYear()
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      
      return `${day}/${month}/${year} ${hours}:${minutes}`
    },
  },
  async mounted() {
    await this.fetchSundryCostList();
    await this.fetchReasons();
  },
  mixins: [Filter, SuccessMessage, ErrorMessages],
  watch: {
    page() {
      this.fetchSundryCostList()
    },
    perPage() {
      this.fetchSundryCostList()
    },
    reasonsPage() {
      this.fetchReasons()
    },
    perPage() {
      this.fetchReasons()
    },
  }
}
</script>

<style scoped></style>
